export const baseUrlApi = (url: string) => `/api/${url}`;
export const baseApi = (url: string) => url;

export interface IResponseType<T = any> {
  code: number;
  error: boolean;
  message: string;
  data: T extends undefined ? any : T;
}
